module.exports = require('./helpers/bundle-url').getBundleURL('41kH8') + "logo.7718c6df.svg";